
export enum ProTrackingLabelStatusCd {
	ASSIGNED = 'Assigned',
	IN_USE = 'InUse',
	LABEL_CHECKOUT = 'LabelCheckout',
	UNASSIGNED = 'Unassigned'}

